import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { WithTranslations } from 'app/containers/WithTranslations';
import {
    setDepartureLocation,
    requestAutocomplete,
    clearAutocomplete,
    storeCityDetailRequested,
} from 'app/store/actions';
import {
    departureCitySelector,
    autocompleteDepartureCurrentByContinentSelector,
    autocompleteDepartureDefaultByContinentSelector,
    errorDepartureSelector,
    autocompleteDepartureLoadingSelector,
} from 'app/store/selectors';
import { emitFieldChangedEvent, emitFieldOpenedEvent, emitFieldClosedEvent } from 'app/events';
import { FIELD_DEPARTURE_CITY } from 'app/storage/fieldNames';
import { TripLocationPicker } from 'app/components/ui/TripLocationPicker';

const mapStateToProps = state => ({
    selected: departureCitySelector(state),
    autocompleteResults: autocompleteDepartureCurrentByContinentSelector(state),
    defaultResults: autocompleteDepartureDefaultByContinentSelector(state),
    autocompleteLoading: autocompleteDepartureLoadingSelector(state),
    error: errorDepartureSelector(state),
    direction: 'departure',
});

const mapDispatchToProps = dispatch => ({
    onChangeLocation: (cityDetails) => {
        dispatch(storeCityDetailRequested(cityDetails));
        dispatch(setDepartureLocation(cityDetails.id));

        // emit external event for tracking/marketing etc
        emitFieldChangedEvent('location.departure', cityDetails.name);
    },
    onClearAutocomplete: () => dispatch(clearAutocomplete('departure')),
    onRequestAutocomplete: query => (
        dispatch(requestAutocomplete(query, 'departure', 'current'))
    ),
    onRequestDefaultAutocomplete: query => dispatch(requestAutocomplete(query, 'departure', 'default')),
});

export const TripDepartureLocationPicker = compose(
    WithTranslations({
        translationGetLabel: 'from',
    }),
    connect(mapStateToProps, mapDispatchToProps),
    withProps(() => ({
        onOpen: () => emitFieldOpenedEvent(FIELD_DEPARTURE_CITY),
        onClose: () => emitFieldClosedEvent(FIELD_DEPARTURE_CITY),
    })),
)(TripLocationPicker);
